import { Link } from 'react-router-dom';
import { gameCategories } from '@/mocks/games';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            黄油网页游戏分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            八大黄油网页游戏分类，快速定位你喜欢的游戏类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {gameCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100/70 group-hover:bg-primary-200 transition-colors">
                <i className={`${category.icon} text-2xl text-primary-600`}></i>
              </div>
              <span className="font-heading text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {category.name}
              </span>
              <span className="text-xs text-foreground-400">
                黄油网页游戏
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}